import { PropsWithChildren, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { dlPushEvent, GTMNoScript, initGTM } from "./gtm";

const GTM_ID = import.meta.env.VITE_GTM_ID as string;

export default function AnalyticsProvider({ children }: PropsWithChildren) {
  const location = useLocation();

  useEffect(() => {
    initGTM(GTM_ID);
  }, []);

  useEffect(() => {
    dlPushEvent("page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title || undefined,
      page_location: window.location.href,
    });
  }, [location]);

  return (
    <>
      <GTMNoScript containerId={GTM_ID} />
      {children}
    </>
  );
}
